import { EnvironmentConfig } from '../app/core/environment-config';

export const environment: EnvironmentConfig = {
    name: 'dev',
    production: false,
    sentryDSN: 'https://6579675205169a8d761f143939dc4cfe@o4507408233857024.ingest.de.sentry.io/4510620430172240',
    buildTag: '',
    backend: 'https://aiconicsandbox.tech/api',
    ontology: 'https://datahub.aiconicsandbox.tech/sso',
    langfuseUrl: '',
};
